import { Component, ElementRef } from '@angular/core';
import { LayoutService } from "./service/app.layout.service";
import { AuthStateService } from '../shared/auth-state.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html',
})
export class AppSidebarComponent {
    constructor(public layoutService: LayoutService,private authStateService: AuthStateService, public el: ElementRef) { }
}

